module.exports = __webpack_public_path__ + "static/media/bg-photo@3x.65e93886.png";